import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { routes } from "../../utils/route.utils";
import { arrayMap, findItemByFiled } from "../../utils/array.utils";
import PageLayout from "../../layouts/PageLayout";

export default function SettingsPage({ name = "Settings" }) {
  const navigate = useNavigate();

  const data = findItemByFiled(routes, "name", name);

  const childrenLength = data?.children?.length;

  const handleRoute = (route) => {
    navigate(route);
  };

  const breadCrumbs = [
    {
      name: "Pages",
      link: "/pages"
    },
    {
      name: "Settings"
    }
  ];

  return (
    <PageLayout
      title={data?.name ?? ""}
      subTitle={`Total: ${childrenLength}`}
      breadCrumbs={breadCrumbs}>
      <div className="row g-3">
        {arrayMap(data?.children, (item, index) => (
          <CardContainer
            key={index + 1}
            className="col-12 col-md-4 col-xl-3"
            onClick={() => handleRoute(item?.route)}>
            <div className="card ">
              <div className="card-body">{item?.name ?? ""}</div>
            </div>
          </CardContainer>
        )) || <div className="text-center">No settings</div>}
      </div>
    </PageLayout>
  );
}

const CardContainer = styled.div`
  cursor: pointer;

  .card {
    transition: background-color 0.3s ease;
    font-size: 0.8rem;
    font-weight: 600;
    border: 0;
    background-color: rgb(var(--primary) / 0.1);
  }

  .card:hover {
    border: 0;
    background-color: rgb(var(--primary) / 1);
    color: white;
  }
`;
